module.exports = require('./helpers/bundle-url').getBundleURL('fmqSe') + "logo-dark.eefe0b7f.svg";